<template>
  <v-row>
    <v-col cols="12">
      <h3>Cached Audio Files ({{ formatBytes(totalSize) }})</h3>
      <v-btn icon color="red" @click="deleteAllFiles">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <v-list two-line>
        <v-list-item v-for="(file, index) in cachedFiles" :key="index">
          <v-list-item-content>
            <v-list-item-title>{{ file.url }}</v-list-item-title>
            <v-list-item-subtitle>
              Size: {{ formatBytes(file.size) }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon color="red" @click="deleteFile(file)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "CachedAudioList",
  data() {
    return {
      cachedFiles: [],
      audio: null
    };
  },
  mounted() {
    this.loadCache();
  },
  computed: {
    totalSize() {
      return this.cachedFiles.reduce((acc, file) => acc + file.size, 0);
    }
  },
  methods: {
    async loadCache() {
      const cache = await caches.open("mp3-cache-v1");
      const requests = await cache.keys();

      const files = await Promise.all(
        requests.map(async (req) => {
          const resp = await cache.match(req);
          const blob = await resp.blob();
          return {
            url: req.url,
            size: blob.size,
            blob
          };
        })
      );

      this.cachedFiles = files;
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    async deleteFile(file) {
      const cache = await caches.open("mp3-cache-v1");
      await cache.delete(file.url);
      this.loadCache(); // refresh list
    },
    async deleteAllFiles() {
      const cache = await caches.open("mp3-cache-v1");
      const requests = await cache.keys();
      await Promise.all(requests.map(req => cache.delete(req)));
      this.loadCache(); // refresh list
    } 
  }
};
</script>